<template>
    <span class="date-style">
        {{currDate}}
    </span>
</template>
<script>
    export default {
        name:'CurrentDate',
        data(){
            return {
                currDate:"",
                timer:null
            }
        },
        mounted() {
            // 页面加载完后显示当前时间
            this.currDate = this.getCurrentDate(new Date());
            // 定时器
            if(null==this.timer){
                this.timer = setInterval(() => {
                    this.currDate = this.getCurrentDate(new Date()) // 修改数据date
                }, 1000*60);
            }
        },
        beforeDestroy() {
            if (this.timer) {
                clearInterval(this.timer);
                this.timer = null;
            }
        },
        methods:{
            getCurrentDate(currDate){
                let formatDateTime
                let Y = currDate.getFullYear()
                let M = currDate.getMonth() + 1
                let D = currDate.getDate()
                let W = currDate.getDay()
                switch (W) {
                    case 0:
                        W = '天'
                        break
                    case 1:
                        W = '一'
                        break
                    case 2:
                        W = '二'
                        break
                    case 3:
                        W = '三'
                        break
                    case 4:
                        W = '四'
                        break
                    case 5:
                        W = '五'
                        break
                    case 6:
                        W = '六'
                        break
                    default:
                        break
                }
                formatDateTime = Y + '年' + M + '月' + D + '日 ' + ' 星期' + W
                return formatDateTime
            }
        }
    }
</script>
<style scoped>
    .date-style {
        font-size: 14px;
        line-height: 25px;
    }
</style>